import {ProgressBar} from './progress-bar';

const LoyaltyLevels = {
  1: {
    MIN: 0,
    MAX: 20000
  },
  2: {
    MIN: 20001,
    MAX: 50000
  },
  3: {
    MIN: 50001,
    MAX: 80000
  },
}

const loyaltyProgressBar = () => {
  const progressBarContainer = document.querySelector(`.js-loyalty-progress`);

  if (progressBarContainer) {
    const sum = +progressBarContainer.querySelector(`[data-loyalty-sum]`).dataset.loyaltySum;

    const step1bar = new ProgressBar(progressBarContainer.querySelector(`#step-1`));
    const step2bar = new ProgressBar(progressBarContainer.querySelector(`#step-2`));
    const step3bar = new ProgressBar(progressBarContainer.querySelector(`#step-3`));

    const getPercent = (levelOption) => {
      const max = levelOption.MAX - levelOption.MIN;
      const changedSum = sum - levelOption.MIN;

      return changedSum / max * 100;
    }

    const setProgress = async () => {
      if (sum > LoyaltyLevels['3'].MAX) {
        await step1bar.setProgress(100);
        await step2bar.setProgress(100);
        await step3bar.setProgress(100);
        return;
      }

      if (sum >= LoyaltyLevels['3'].MIN && sum <= LoyaltyLevels['3'].MAX) {
        await step1bar.setProgress(100);
        await step2bar.setProgress(100);
        await step3bar.setProgress(getPercent(LoyaltyLevels['3']));
        return;
      }

      if (sum >= LoyaltyLevels['2'].MIN && sum <= LoyaltyLevels['2'].MAX) {
        await step1bar.setProgress(100);
        await step2bar.setProgress(getPercent(LoyaltyLevels['2']))
        return;
      }

      if (sum <= LoyaltyLevels['1'].MAX) {
        await step1bar.setProgress(getPercent(LoyaltyLevels['1']));
      }
    }

    setProgress().then().catch((error) => console.log(error));
  }
}

export default loyaltyProgressBar;
